import React, { useState } from "react";
import {
  Box,
  Text,
  Flex,
  FormControl,
  Input,
  FormLabel,
  Button,
  Heading,
  Container,
  Spinner, useToast
} from "@chakra-ui/react";
import { useHistory } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";

import { Separator, ErrorBox, View, ModalBox } from "@components";
import { Logo, IconSuccess } from "@assets/Icons";
import { forgotPasswordSchema } from "@lib/validationData";
import { forgotPassword } from "@lib/datahandlers/auth";
import Layout from "./Layout";
import { t } from "@lang/i18n";


const ForgotPasswordScreen = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [showModalBox, setShowModalBox] = useState(false);

  const history = useHistory();
  const toast = useToast();
  const { register, handleSubmit, getValues, formState: { errors } } = useForm({
    resolver: yupResolver(forgotPasswordSchema)
  });

  const closeModal = () => {
    setShowModalBox(false);
    history.push('/login');
  };

  const submitFormWithKeyboard = (e) => {
    if (e.code === 'Enter') onForgot({ email: getValues('email') })
  };

  const errorHandling = (obj) => {
    return Object.keys(obj).map(function(key) {
      if (obj[key].length === 1) return obj[key].join('')
      else return obj[key]
    });
  };

  const onForgot = async (data) => {
    if (typeof data === 'undefined') return;
    setIsLoaded(true)

    const result = await forgotPassword(data);

    if (result.success) {
      setShowModalBox(true);
      setIsLoaded(false);
      return;
    }
    setIsLoaded(false);
    toast({ description: result.errorMessages ? errorHandling(result.errorMessages) : t('messages.error.forgot_password') , status: "error", position: "bottom-right", variant: "left-accent", isClosable: true });
  };

  return (
    <Layout menuType="candidate" isFooterVisible>
      <View if={showModalBox}>
        <ModalBox isOpen={showModalBox}>
          <Box mb="30px">
            <IconSuccess iconType="both" />
          </Box>
          <Text
            color="black"
            textAlign="center"
            fontSize="1rem"
            fontWeight="400"
            letterSpacing="2%"
          >
            { t('auth.forgot_password.success') }
          </Text>

          <Button
            bg="gradient"
            borderRadius="24px"
            color="white"
            w="164px"
            my="20px"
            mt="26px"
            _hover={{ bg: "gradient", opacity: ".7" }}
            onClick={() => closeModal()}
          >
            { t('global.close') }
          </Button>
        </ModalBox>
      </View>

      <Container maxW="429px" bg="white" py="39px" px={["16px","","","42px"]} m="63px auto 129px auto" borderRadius="4px">
        <Flex flexDir="column">
          <Box mx="auto" mb="26px">
            <Logo logoType="auth" />
          </Box>

          <Heading as="h1" fontSize="30px" color="black" textAlign="center" fontWeight="700">
            { t('auth.forgot_password.title') }
          </Heading>

          <Separator />

          <Text fontSize="16px" textAlign="left" maxW="344px" mx="auto" color="black" mb="16px" fontWeight="normal" letterSpacing=".02em">
            { t('auth.forgot_password.description') }
          </Text>

          <form onSubmit={handleSubmit(onForgot)}>
            <FormControl id="email" mb="16px" maxW="344px" mx="auto">
              <FormLabel color="#333" fontSize="16px" fontWeight="300" ml="5px">
              { t('fields.email') }
              </FormLabel>
              <Input
                type="email"
                placeholder={ t('fields.email') }
                isInvalid={errors.email ? true : false}
                errorBorderColor="error"
                borderColor="gray.borders"
                focusBorderColor={errors.email ? "error" : "blue.light"}
                borderRadius="4px" bg="white" mb="2px" maxW="344px" h="46px"
                {...register("email")}
              />
              {errors.email && <ErrorBox error={errors.email.message} />}
            </FormControl>

            <Button type="submit"
              w={["75vw",  "18rem", "", ""]} borderRadius="24px" border="2px solid" bg="gradient" color="white" m="16px auto 0 auto" 
              display="flex" h="46px" p="0"
              _hover={{ bg: "gradient" }}>
              {isLoaded? <Spinner size="md" /> : t("global.send")}
            </Button>
          </form>
        </Flex>
      </Container>
    </Layout>
  );
};

export default ForgotPasswordScreen;
